import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TopBarLayout } from './TopBarLayout';
import { useTopBar } from '../hooks/useTopBar';
const TopBarLayoutContainer = (props) => {
    const { children } = props;
    const { leftRef, centerRef, rightRef } = useTopBar();
    const childrenWithRefs = React.Children.map(children, (child) => {
        if (!React.isValidElement(child))
            return child;
        if (child.type === TopBarLayout.Left)
            return React.cloneElement(child, { ref: leftRef });
        if (child.type === TopBarLayout.Center)
            return React.cloneElement(child, { ref: centerRef });
        if (child.type === TopBarLayout.Right)
            return React.cloneElement(child, { ref: rightRef });
        return child;
    });
    return _jsx(TopBarLayout, { children: childrenWithRefs });
};
export const TopBar = Object.assign(TopBarLayoutContainer, {
    Left: TopBarLayout.Left,
    Center: TopBarLayout.Center,
    Right: TopBarLayout.Right,
});
